<template>
	<div>
		<el-row :gutter="4"
			style="border-bottom: 1px solid #ebeef5;padding-bottom: 20px;background-color: blue;height: 50px">
			<el-col :span="4"></el-col>
			<el-col :span="14" style="text-align: center;">
				<div style="font-size: 30px;color: white;">中级消防设施操作员理论-模拟考试
					{{ paperInfo.name }}
				</div>
			</el-col>
			<el-col :span="6">
				<el-menu mode="horizontal">
					<el-sub-menu index="1">
						<template #title>
							<div style="font-size: 20px;border-bottom-color: transparent;">欢迎 {{ loginNickName }}</div>
						</template>
						<el-menu-item @click="handleToPage('/')" index="home">首页</el-menu-item>
            <el-menu-item v-if="!isBuy" @click="handleToTryPractice('/fire/try/practice/theoryMediumDevice','try', 'practice','theory')" index="theoryPracticeTry">理论练习</el-menu-item>
            <el-menu-item v-if="!isBuy" @click="handleToTryPractice('/fire/try/exam/theoryMediumDevice','try', 'exam','theory')" index="theoryExamTry">模拟理论考试</el-menu-item>
            <el-menu-item v-if="!isBuy" @click="handleToTryPractice('/fire/try/practice/peopleMediumDevice','try', 'practice','people')" index="peoplePracticeTry">操作题练习</el-menu-item>
            <el-menu-item v-if="!isBuy" @click="handleToTryPractice('/fire/try/exam/peopleMediumDevice','try', 'exam','people')" index="peoplePracticeTry">操作题考试</el-menu-item>
            <el-menu-item v-if="isBuy" @click="handleToTryPractice('/fire/normal/practice/theoryMediumDevice','normal', 'practice','theory')" index="theoryPractice">理论练习</el-menu-item>
            <el-menu-item v-if="isBuy" @click="handleToTryPractice('/fire/normal/exam/theoryMediumDevice','normal', 'exam','theory')" index="theoryExam">模拟理论考试</el-menu-item>
            <el-menu-item v-if="isBuy" @click="handleToTryPractice('/fire/normal/practice/peopleMediumDevice','normal', 'practice','people')" index="peoplePractice">操作题练习</el-menu-item>
            <el-menu-item v-if="isBuy" @click="handleToTryPractice('/fire/normal/exam/peopleMediumDevice','normal', 'exam','people')" index="peopleExam">操作题考试</el-menu-item>


          </el-sub-menu>
				</el-menu>
			</el-col>
		</el-row>
		<transition name="fade">
			<div v-if="isLoading" class="loading-screen">
				<div class="loading-icon"></div>
			</div>
			<div v-else>
				<div>
					<el-row>
						<el-col :span="4" style="height:600px;overflow-y:auto">
							<div
								style="border-left: 2px solid blue;padding-bottom: 5px;padding-top: 5px;margin-bottom: 10px">
								答题卡
								<el-button style="width: 25px;height:20px;margin-left: 0"></el-button>
								未答
								<el-button style="width: 25px;height:20px;margin-left: 0" type="primary"></el-button>
								已答
							</div>
							<el-row v-for="paperDetailInfo in paperDetailInfos" :key="paperDetailInfo.id">

								<div style="border-left: 2px solid orange;padding-bottom: 5px;padding-top: 5px;">
									{{ paperDetailInfo.name }}(共{{ paperDetailInfo.totalCount }}题,合计{{paperDetailInfo.totalCount*paperDetailInfo.perScore}}分)
									<br>
								</div>
								<div>
									<el-button v-for="index in paperDetailInfo.totalCount" :key="index"
										:style="givenButtonStyle(index-1,paperDetailInfo.type)"
										@click="getGivenQuestion(paperInfo.id, index, paperDetailInfo.type)">
										{{ index }}
									</el-button>
								</div>
							</el-row>


						</el-col>
						<el-col :span="16" style="height:600px;overflow-y:auto">

							<span style="float: right;font-size: 16px;margin-right: 10px">
								字体[
								<el-link style="font-size: 16px;margin-right: 10px"
									@click="changePaperFontStyle(18)">大</el-link>
								<el-link style="font-size: 16px;margin-right: 10px"
									@click="changePaperFontStyle(16)">中</el-link>
								<el-link style="font-size: 16px;margin-right: 10px"
									@click="changePaperFontStyle(14)">小</el-link>
								]
							</span>
							<el-row v-for="paperDetailInfo in paperDetailInfos" :key="paperDetailInfo.id">
								<div style="margin-left: 10px">
									<div v-if="paperDetailInfo.type==='singleChoice'">
										<div class="questionStyle" style="font-weight: bold; margin-bottom: 10px;">
											一.{{ paperDetailInfo.name }}(共{{ paperDetailInfo.totalCount }}题,合计{{paperDetailInfo.totalCount*paperDetailInfo.perScore}}分)
										</div>
										<el-row style="width: 100%"
											v-for="(paperContentInfo,contentIndex) in paperContentSingleChoiceInfos"
											:key="contentIndex">
											<div class="questionStyle" :id="'singleChoice'+(contentIndex+1)">
												{{ contentIndex+1}}.{{paperContentInfo.question}}
											</div>
											<br>
											<el-radio-group
												v-for="(answerInfo, singleChoiceAnswerIndex) in paperContentInfo.questionAnswerDtoList"
												:key="singleChoiceAnswerIndex"
												v-model="answer.singleChoiceArray[paperContentInfo.id]">
												<el-radio :label="answerInfo.alphabet" :value="singleChoiceAnswerIndex"
													@click="getCurrentChoice(answerInfo, paperContentInfo.id, paperContentInfo.type,contentIndex,paperContentInfo.paperId)">
													{{ answerInfo.alphabet }}.{{ answerInfo.content }}
												</el-radio>
											</el-radio-group>

										</el-row>
									</div>
									<div v-if="paperDetailInfo.type==='multipleChoice'">
										<div class="questionStyle" style="font-weight: bold; margin-bottom: 10px;">
											二.{{ paperDetailInfo.name }}(共{{ paperDetailInfo.totalCount }}题,合计{{paperDetailInfo.totalCount*paperDetailInfo.perScore}}分)
										</div>
										<el-row style="width: 100%"
											v-for="(paperContentInfo,contentIndex) in paperContentMultipleChoiceInfos"
											:key="contentIndex">
											<div :id="'multipleChoice'+(contentIndex+1)" class="questionStyle">
												{{ contentIndex+1}}.{{
                          paperContentInfo.question
                        }}
											</div>
											<el-checkbox-group style="margin-right: 10px;"
												v-model="answer.multiplyChoiceArray[paperContentInfo.id]">
												<el-checkbox :label="answerInfo.alphabet" :value="answerInfo.alphabet"
													v-for="answerInfo in paperContentInfo.questionAnswerDtoList"
													:key="answerInfo.id"
													@change="getCurrentMultipleChoice(answerInfo, paperContentInfo.id, paperContentInfo.type,contentIndex, paperContentInfo.paperId)">
													{{ answerInfo.alphabet }}.{{ answerInfo.content }}
												</el-checkbox>
											</el-checkbox-group>
										</el-row>
									</div>
									<div v-if="paperDetailInfo.type==='judgment'">
										<div class="questionStyle" style="font-weight: bold; margin-bottom: 10px;">
											三.{{ paperDetailInfo.name }}(共{{ paperDetailInfo.totalCount }}题,合计{{paperDetailInfo.totalCount*paperDetailInfo.perScore}}分)

										</div>
										<el-row style="width: 100%"
											v-for="(paperContentInfo,contentIndex) in paperContentJudgmentInfos"
											:key="contentIndex">
											<div :id="'judgment'+(contentIndex+1)" class="questionStyle">
												{{ contentIndex+1}}.{{
                          paperContentInfo.question
                        }}
											</div>
											<br>
											<el-radio-group
												v-for="(answerInfo,index) in paperContentInfo.questionAnswerDtoList"
												:key="index" v-model="answer.judgmentArray[paperContentInfo.id]">
												<el-radio :label="answerInfo.alphabet"
													@click="getCurrentChoice(answerInfo, paperContentInfo.id, paperContentInfo.type,contentIndex, paperContentInfo.paperId)">
													{{ answerInfo.alphabet }}.{{ answerInfo.content }}
												</el-radio>
											</el-radio-group>
										</el-row>
									</div>
								</div>
							</el-row>
						</el-col>
						<el-col :span="4" style="font-size: 16px">
							<div style="padding-left: 40px;"><img
									:src="require(`@/assets/picture/FireEngine/studentHeadPicture.png`)" alt="headImg"
									style="width: 150px;height: 150px"></div>
							<div style="border-bottom: 1px solid #ebeef5;padding-bottom: 20px;">
								考生姓名:{{ loginNickName }}<br>
								身份证号:119**********888<br>
								网络状态：<span style="color: darkgreen">正常</span>
							</div>
							<div style="border-bottom: 1px solid #ebeef5;padding-bottom: 20px;padding-top:20px;">
								剩余时间:<span
									style="color: red">{{ remainingHours }}:{{ remainingMinutes }}:{{ remainingSeconds }}</span>
							</div>
							<div style="border-bottom: 1px solid #ebeef5;padding-bottom: 20px;padding-top: 20px;">当前进度
								<el-progress type="line" :percentage="percentage" color="orange"></el-progress>
							</div>
							<div style="font-size: 14px;color: red">注意:答题时间到后,若未点交卷,系统会自动提交考卷。请注意答题时间!</div>
							<el-button @click="confirmSubmit" type="primary"
								style="margin-top: 20px;width: 100%">点击交卷</el-button>

							<el-dialog v-model="isSubmitting" title="提示" width="40%">
								<div style="margin-top: 0;font-size: 16px">你正准备交卷</div>
								<div style="margin-top: 0;font-size: 16px">
									目前完成了{{selectedQuestions.length}}，总共{{paperTotalCount}}道题，还有
									<span style="color: red">{{paperTotalCount-selectedQuestions.length}}</span> 道题未做
								</div>
								<div style="margin-top: 0;font-size: 16px;margin-bottom: 20px">请确认是否交卷?</div>

								<span class="dialog-footer">
									<el-button @click="isSubmitting=false" style="float:right;margin-right: 20px">取
										消</el-button>
									<el-button type="primary" @click="submitExam"
										style="float:right;margin-right: 20px">确 定</el-button>
								</span>
							</el-dialog>
						</el-col>

					</el-row>
				</div>
			</div>
		</transition>



	</div>


</template>

<script>
	import {
		useRoute
	} from "vue-router/dist/vue-router";
	import request from "@/utils/request";
	import {
		ElMessage
	} from "element-plus";
	import router from "@/router";
	import {
		ref
	} from "vue";


	const loginNickName = localStorage.getItem("loginNickName");
	const loginUserId = localStorage.getItem("loginUserId");

	const percentage = ref(0);
	const paperTotalCount = ref(200);

	const selectedQuestions = ref([]);

	const givenButtonSingleChoiceColor = ref([]);
	const givenButtonMultipleChoiceColor = ref([]);
	const givenButtonJudgmentChoiceColor = ref([]);

	const paperDetailInfos = ref([{
			"description": null,
			"id": 1000,
			"limitTime": 120,
			"name": "单选题",
			"paperId": 1000,
			"perScore": "0.5",
			"totalCount": 100,
			"type": "singleChoice"
		},
		{
			"description": null,
			"id": 1000,
			"limitTime": 120,
			"name": "多选题",
			"paperId": 1000,
			"perScore": "0.5",
			"totalCount": 40,
			"type": "multipleChoice"
		},
		{
			"description": null,
			"id": 1000,
			"limitTime": 120,
			"name": "判断题",
			"paperId": 1000,
			"perScore": "0.5",
			"totalCount": 60,
			"type": "judgment"
		}
	])

	const paperContentSingleChoiceInfos = ref([]);
	const paperContentMultipleChoiceInfos = ref([]);
	const paperContentJudgmentInfos = ref([]);
	let beginExamTime = new Date();

	const isBuy = ref(false);
	const areaId = ref('');
	const subjectId = ref('');

	function getUserAuthorization(paperId) {
		request.get('/userAuthorization/check', {
				params: {
					userId: loginUserId,
					paperId: paperId,
					type: "subject"
				}
			})
			.then(response => {
				const result = response.data; // 将接口返回的数据赋值给result
				if (result.code === "200") {
					isBuy.value = result.data.checked;
				} else {
					ElMessage.warning(result.msg);
					router.push("/login");
				}
			})
			.catch(error => {
				console.log("TheoryMediumDevice error:" + error);
				// ElMessage.error("系统异常，请联系管理员");
			});
	}

	async function submitExamInfos(paperId) {
		request.post('/examInfo/', {
				"userId": loginUserId,
				"selectedAnswers": selectedQuestions.value,
				"paperId": paperId,
				"type": "theory",
				"usedTime": new Date().getTime() - beginExamTime.getTime()
			}, {
				headers: {
					'Content-Type': 'application/json;charset=utf-8'
				}
			})
			.then(async response => {
				const result = response.data; // 将接口返回的数据赋值给result
				if (result.code === "200") {
					await updatePaperContentQuestionInfoByExam.call(this, paperId);
					await updateUserQuestionByExam.call(this, paperId, result.data.examId);
					selectedQuestions.value = [];
					givenButtonSingleChoiceColor.value = [];
					givenButtonMultipleChoiceColor.value = [];
					givenButtonJudgmentChoiceColor.value = [];
					await router.push({
						path: "/fire/ExamScore",
						query: {
							examId: result.data.examId,
							examType: "theory",
							paperId: paperId,
							areaId: areaId.value,
							paperStatus: paperStatus.value,
							subjectId: subjectId.value
						}
					});
				} else {
					ElMessage.warning(result.msg);
					router.push("/login");
				}
			})
			.catch(error => {
				console.log("TheoryMediumDevice error:" + error);
				// ElMessage.error("系统异常，请联系管理员");
			});
	}

	async function updateUserQuestionByExam(paperId, examId) {
		request.put('/userQuestionInfo/exam', {
				"userId": loginUserId,
				"selectedAnswers": selectedQuestions.value,
				"paperId": paperId,
				"examId": examId,
				"type": "theory",
				"usedTime": new Date().getTime() - beginExamTime.getTime()
			})
			.then(response => {
				const result = response.data; // 将接口返回的数据赋值给result
				if (result.code !== "200") {
					ElMessage.warning(result.msg);
				}
			})
			.catch(error => {
				console.log("TheoryMediumDevice error:" + error);
				// ElMessage.error("系统异常，请联系管理员");
			});
	}


	async function updatePaperContentQuestionInfoByExam(paperId) {
		request.put('/paperContentQuestionInfo/exam', {
				"userId": loginUserId,
				"selectedAnswers": selectedQuestions.value,
				"paperId": paperId,
				"type": "theory",
				"usedTime": new Date().getTime() - beginExamTime.getTime()
			})
			.then(response => {
				const result = response.data; // 将接口返回的数据赋值给result
				if (result.code !== "200") {
					ElMessage.warning(result.msg);
				}
			})
			.catch(error => {
				console.log("TheoryMediumDevice error:" + error);
				// ElMessage.error("系统异常，请联系管理员");
			});
	}

	async function getPaperContentInfosByRamdom(questionType, subjectId, totalNumber) {
		await request.get('/paperContentInfo/randomExam/all', {
				params: {
					userId: loginUserId,
					questionType: questionType,
					subjectId: subjectId,
					totalNumber: totalNumber
				}
			})
			.then(response => {
				const result = response.data; // 将接口返回的数据赋值给result
				if (result.code === "200") {
					if (questionType === "singleChoice") {
						paperContentSingleChoiceInfos.value = result.data;
					}
					if (questionType === "multipleChoice") {
						paperContentMultipleChoiceInfos.value = result.data;
					}
					if (questionType === "judgment") {
						paperContentJudgmentInfos.value = result.data;
					}
				} else {
					ElMessage.warning(result.msg);
					router.push("/login");
				}
			})
			.catch(error => {
				console.log("TheoryMediumDevice error:" + error);
				// ElMessage.error("系统异常，请联系管理员");
			});
	}

	async function getPaperContentInfos(paperId, questionType) {
		await request.get('/paperContentInfo/all', {
				params: {
					userId: loginUserId,
					paperId: paperId,
					questionType: questionType
				}
			})
			.then(response => {
				const result = response.data; // 将接口返回的数据赋值给result
				if (result.code === "200") {
					if (questionType === "singleChoice") {
						paperContentSingleChoiceInfos.value = result.data;
					}
					if (questionType === "multipleChoice") {
						paperContentMultipleChoiceInfos.value = result.data;
					}
					if (questionType === "judgment") {
						paperContentJudgmentInfos.value = result.data;
					}
				} else {
					ElMessage.warning(result.msg);
					router.push("/login");
				}
			})
			.catch(error => {
				console.log("TheoryMediumDevice error:" + error);
				// ElMessage.error("系统异常，请联系管理员");
			});
	}

	function getPaperInfo(paperId) {
		request.get('/paperInfo/paperId', {
				params: {
					userId: loginUserId,
					paperId: paperId
				}
			})
			.then(response => {
				const result = response.data; // 将接口返回的数据赋值给result
				if (result.code === "200") {
					this.paperInfo = result.data;
				} else {
					ElMessage.warning(result.msg);
					router.push("/login");
				}
			})
			.catch(error => {
				console.log("TheoryMediumDevice error:" + error);
				// ElMessage.error("系统异常，请联系管理员");
			});
	}

	function getPaperDetailInfos(paperId) {
		request.get('/paperDetailInfo/', {
				params: {
					userId: loginUserId,
					paperId: paperId
				}
			})
			.then(response => {
				const result = response.data; // 将接口返回的数据赋值给result
				if (result.code === "200") {
					paperDetailInfos.value = result.data;
				} else {
					ElMessage.warning(result.msg);
					router.push("/login");
				}
			})
			.catch(error => {
				console.log("TheoryMediumDevice error:" + error);
				// ElMessage.error("系统异常，请联系管理员");
			});
	}


	const paperFontSize = ref('16px');
	// const userAnswer= ref([]);
	const paperId = ref('');
	const paperStatus = ref('');

	export default {
		name: "TheoryPaperExam",
		data() {
			return {
				loginNickName: loginNickName,
				paperInfo: '',
				paperDetailInfos: paperDetailInfos,
				paperContentSingleChoiceInfos: paperContentSingleChoiceInfos,
				paperContentMultipleChoiceInfos: paperContentMultipleChoiceInfos,
				paperContentJudgmentInfos: paperContentJudgmentInfos,
				percentage: percentage,
				givenButtonSingleChoiceColor: givenButtonSingleChoiceColor,
				givenButtonMultipleChoiceColor: givenButtonMultipleChoiceColor,
				givenButtonJudgmentChoiceColor: givenButtonJudgmentChoiceColor,
				paperFontSize: paperFontSize,
				isLoading: true,
				isSubmitting: false,
				answer: {
					singleChoiceArray: [],
					multiplyChoiceArray: [],
					judgmentArray: [],
				},
				selectedQuestions: selectedQuestions,
				// selectedQuestionCount:selectedQuestionCount,
				paperId: paperId,
				isBuy: isBuy,
			}
		},
		async created() {
			setTimeout(() => {
				this.isLoading = false
			}, 2000)
			const route = useRoute();
			paperId.value = route.query.paperId;
			areaId.value = route.query.areaId;
			paperStatus.value = route.query.paperStatus;
			subjectId.value = route.query.subjectId
			this.getUserAuthorization(paperId.value);
			if (paperStatus.value === "randomExam") {
				await getPaperContentInfosByRamdom.call(this, "singleChoice", subjectId.value, 100);
				await getPaperContentInfosByRamdom.call(this, "multipleChoice", subjectId.value, 40);
				await getPaperContentInfosByRamdom.call(this, "judgment", subjectId.value, 60);
			} else {
				this.getPaperInfo(paperId.value);
				this.getPaperDetailInfos(paperId.value);
				await this.getPaperContentInfos(paperId.value, "singleChoice");
				await this.getPaperContentInfos(paperId.value, "multipleChoice");
				await this.getPaperContentInfos(paperId.value, "judgment");
			}

			for (let i = 0; i < paperContentSingleChoiceInfos.value.length; i++) {
				givenButtonSingleChoiceColor.value.push("light-gray");
			}
			for (let i = 0; i < paperContentMultipleChoiceInfos.value.length; i++) {
				givenButtonMultipleChoiceColor.value.push("light-gray");
			}
			for (let i = 0; i < paperContentJudgmentInfos.value.length; i++) {
				givenButtonJudgmentChoiceColor.value.push("light-gray");
			}
		},
		methods: {
			handleToPage(path) {
				router.push(path);
			},
			handleToTryPractice(trainPath, buyMode, studyMode, subjectType) {
				router.push({
					path: trainPath,
					query: {
						areaId: areaId.value,
						studyMode: studyMode,
						buyMode: buyMode,
						subjectType: subjectType
					}
				});
			},
			getUserAuthorization(paperId) {
				getUserAuthorization.call(this, paperId)
			},
			getPaperInfo(paperId) {
				getPaperInfo.call(this, paperId);
			},
			getPaperDetailInfos(paperId) {
				getPaperDetailInfos.call(this, paperId);
			},
			async getPaperContentInfos(paperId, questionType) {
				await getPaperContentInfos.call(this, paperId, questionType)
			},
			getCurrentChoice(answerInfo, questionId, questionType, questionIndex, paperId) {
				// chooseAnswerInfo.value = answerInfo;
				const selectedQuestion = selectedQuestions.value.find(item => item.questionId === questionId);
				if (selectedQuestion) {
					selectedQuestion.isCorrect = answerInfo.answer;
					selectedQuestion.answerInfos = [answerInfo];
				} else {
					selectedQuestions.value.push({
						"questionId": questionId,
						"correct": answerInfo.answer,
						"answerInfos": [answerInfo],
						"type": questionType,
						"paperId": paperId
					});
				}
				this.changeGivenButtonColor(questionId, questionIndex, questionType);
				percentage.value = Math.floor((selectedQuestions.value.length / paperTotalCount.value) * 100);
			},
			getCurrentMultipleChoice(answerInfo, questionId, questionType, questionIndex, paperId) {
				const selectedQuestion = selectedQuestions.value.find(item => item.questionId === questionId);
				if (selectedQuestion) {
					selectedQuestion.correct = this.checkAnswerIsCorrect(questionType, answerInfo, questionId);
					selectedQuestion.answerInfos = this.answer.multiplyChoiceArray[questionId];
				} else {
					selectedQuestions.value.push({
						"questionId": questionId,
						"correct": this.checkAnswerIsCorrect(questionType, answerInfo, questionId),
						"answerInfos": this.answer.multiplyChoiceArray[questionId],
						"type": questionType,
						"paperId": paperId
					});
				}
				this.givenButtonMultipleChoiceColor[questionIndex] = "blue";
				percentage.value = Math.floor((selectedQuestions.value.length / paperTotalCount.value) * 100);
			},

			getGivenQuestion(paperId, index, type) {
				//定位到对应的题目
				const element = document.querySelector('#' + type + index);
				if (element) {
					element.scrollIntoView({
						behavior: "smooth"
					});
				}
			},

			checkAnswerIsCorrect(paperType, answerInfo, questionId) {
				if (paperType.value === 'singleChoice' || paperType.value === 'judgment') {
					return answerInfo.value.answer;
				}
				if (!answerInfo.answer) {
					return false
				}
				let correctAnswerString = answerInfo.correctAnswerAlphabet.toString().replaceAll(",", "")
				if (this.answer.multiplyChoiceArray[questionId].length > correctAnswerString.length) {
					return false;
				}
				if (this.answer.multiplyChoiceArray[questionId].length === correctAnswerString.length) {
					return this.answer.multiplyChoiceArray[questionId].every((element) => correctAnswerString.includes(
						element));
				}
				return false;
			},
			changeGivenButtonColor(questionId, index, questionType) {
				const selectQuestion = selectedQuestions.value.find(item => item.questionId === questionId);
				if (selectQuestion) {
					if (questionType === 'singleChoice') {
						this.givenButtonSingleChoiceColor[index] = "blue";
					}
					if (questionType === 'multipleChoice') {
						this.givenButtonMultipleChoiceColor[index] = "blue";
					}
					if (questionType === 'judgment') {
						this.givenButtonJudgmentChoiceColor[index] = "blue";
					}
				}
			},
			getGivenButtonColorByType(questionType, index) {
				if (questionType === 'singleChoice') {
					return this.givenButtonSingleChoiceColor[index];
				}
				if (questionType === 'multipleChoice') {
					return this.givenButtonMultipleChoiceColor[index];
				}
				if (questionType === 'judgment') {
					return this.givenButtonJudgmentChoiceColor[index];
				}
				return "light-gray"
			},

			givenButtonStyle(index, type) {
				return {
					"float": "left",
					"margin-left": 0,
					"margin-bottom": "3px",
					"width": "40px",
					"background-color": this.getGivenButtonColorByType(type, index),
					"color": "black"
				}
			},
			changePaperFontStyle(size) {
				paperFontSize.value = size + "px";
			},
			submitExam() {
				submitExamInfos.call(this, paperId.value);
			},
			confirmSubmit() {
				this.isSubmitting = true;
			}
		},
	}
</script>


<script setup>
	import {
		onMounted,
		onUnmounted
	} from "vue";


	const remainingTime = ref(7200); // 2小时 = 7200秒
	const remainingHours = ref("02");
	const remainingMinutes = ref("00");
	const remainingSeconds = ref("00");


	function getTimeString(number) {
		if (number < 10) {
			return "0" + number;
		} else {
			return number;
		}
	}
	onMounted(() => {
		const intervalId = setInterval(() => {
			if (remainingTime.value > 0) {
				remainingTime.value -= 1;
				remainingHours.value = getTimeString(Math.floor(remainingTime.value / 3600));
				remainingMinutes.value = getTimeString(Math.floor((remainingTime.value % 3600) / 60));
				remainingSeconds.value = getTimeString(Math.floor(remainingTime.value % 60));
			} else {
        submitExamInfos.call(this, paperId.value);
				clearInterval(intervalId);
			}
		}, 1000);
		// 清除定时器
		onUnmounted(() => {
			clearInterval(intervalId);
		});
	});
</script>

<style scoped>
	.mode-col {
		height: 300px;
		width: 400px;
		/* 设置一个高度让背景显示出来 */
		background-size: contain;
		background-repeat: no-repeat;
		/* 背景图片覆盖整个元素 */
		transition: background-image 0.5s;
		/* 可选的，背景图变化过渡效果 */
		align-content: center;
		/*background-color: lightgray;*/
	}

	.el-menu {
		background-color: transparent;
		border-bottom-color: transparent;
	}

	.el-menu-item {
		background-color: transparent !important;
		color: black !important;
		font-weight: 50;
		width: 200px;
		font-size: 18px;
		text-align: center;

		&:not(.is-disabled):hover {
			color: gray !important;
			background-color: lightgray !important;
			width: 200px;
			text-align: center;
		}
	}

	.content {
		flex: 1;
		/* 让内部容器充满剩余空间 */
		display: flex;
		align-items: center;
		/* 垂直居中 */
		justify-content: flex-start;
		/* 水平方向从左边开始排列 */
	}

	.questionStyle {
		font-size: v-bind(paperFontSize);
		width: 100%;
		padding-bottom: 5px;
	}


	.el-radio :deep(.el-radio__label) {
		font-size: v-bind(paperFontSize);
		line-height: 2;
		color: black;
		margin-right: 15px;
	}

	.el-radio :deep(.el-radio__inner) {
		width: 16px;
		height: 16px;
		border-color: black;
	}

	/*.el-radio /deep/.el-radio__input.is-checked .el-radio__inner::after {*/
	/*  !* 更改圆点颜色 *!*/
	/*  background-color: black; !* 例子中使用了红色 *!*/
	/*}*/

	.el-radio :deep(.el-radio__input.is-checked + .el-radio__label) {
		color: black;
	}

	.el-radio :deep(.el-radio__input.is-checked .el-radio__inner) {
		border-color: gray;
		/* 选中边框的颜色 */
		background-color: gray;
		/* 选中背景的颜色 */
	}

	.el-checkbox :deep(.el-checkbox__label) {
		font-size: v-bind(paperFontSize);
		/* 这里设置你想要的字体大小 */
		overflow: hidden;
		white-space: normal;
		word-break: break-all;
		color: black;
	}

	.el-checkbox :deep(.el-checkbox__input.is-checked + .el-checkbox__label) {
		color: black;
		/* 替换为你想要的颜色 */
	}

	.el-checkbox :deep(.el-checkbox__inner) {
		width: 16px;
		/* 修改选框的宽度 */
		height: 16px;
		/* 修改选框的高度 */
		border-color: black;
	}

	.el-checkbox :deep(.el-checkbox__input.is-checked .el-checkbox__inner),
	.el-checkbox :deep(.el-checkbox__input.is-indeterminate .el-checkbox__inner) {
		background-color: black;
		/* 你想要的选中颜色 */
		border-color: black;
	}

	/* 修改选中时的对勾颜色 */
	.el-checkbox :deep(.el-checkbox__input.is-checked .el-checkbox__inner::after) {
		color: black;
		/* 对勾颜色 */
	}

	.loading-screen {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: #fff;
		transition: opacity 1s ease-out;
		opacity: 1;
	}

	.loading-screen.fade-out {
		opacity: 0;
		transition: opacity 1s ease-in;
	}

	.loading-icon {
		/* 动画CSS样式 */
		width: 50px;
		height: 50px;
		border: 6px solid #ddd;
		border-top-color: skyblue;
		border-radius: 50%;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		animation: spin 3s linear infinite;
	}

	@keyframes spin {
		0% {
			transform: translate(-50%, -50%) rotate(0deg);
		}

		100% {
			transform: translate(-50%, -50%) rotate(360deg);
		}
	}
</style>
